const referencedata = [
  {
    name: "Sam S",
    title: "Lead Programmer",
    ref: "Flo is a brilliant programmer and a joy to work with. She stepped into a huge amount of responsibility from day one, taking ownership of multiple complex features and seeing them through with confidence and care. She’s passionate, dependable, and has a sharp eye for both quality and practicality. Flo isn’t afraid to call out when something isn’t working and consistently pushes for better. I’d gladly work with her again, and confidently recommend her for any UI/gameplay programming role.",
  },
  {
    name: "David J",
    title: "Game Director",
    ref: "Flo did some amazing work here at Awe and I could fully trust her to take on any task. She had full ownership of UI, Dialogue, Dialogue Tooling and several other systems. She is friendly, communicative, documents her work and proactively reaches out to colleagues to get things moving.",
  },
];

export default referencedata;
